/**
 * Parcels Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import DetailsUnload from '../parcelUnloadInventoryItems/indexMob'
import DetailsLocat from '../parcelLocateInventoryItems/indexMob'

// Context
import AuthContext from '../../authContext';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Typography,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Box,
  ClickAwayListener,
  Card,
  CardContent,
  TextField,
  Tab,
  Tabs,
} from '@material-ui/core';
// Icon
import Icon from '@mdi/react';
import {
  mdiKeyOutline,
  mdiArrowRight,
  mdiPrinter,
  mdiArchiveOutline,
  mdiMapMarkerCheckOutline,
  mdiClose,
  mdiDotsHorizontalCircleOutline,
  mdiClipboardCheckOutline,
  mdiPlaylistCheck,
  mdiCheckBold,
  mdiArrowCollapseAll,
  mdiFileTree,
  mdiClipboardArrowLeft,
  mdiTableArrowUp,
  mdiTableCheck,
  mdiPackageVariantClosed,
  mdiHomeOutline,
} from '@mdi/js';

// Components
import ListParcelItems from './list';
import Can from '../../components/Can';
import CSV from './csv';
import InventoryItemCSV from './inventoryItemCsv';
import LabelList from '../parcelInventoryItems/components/labelsList';
import Modal from '../../components/Modal';

// Helper
import {
  translate,
  formaterPhoneNumber,
  removeEmptyValueObject,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Props } from './interfaces';
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter, { Filter } from '../../utils/listDaynamicFilter';
import clsx from 'clsx';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import parcelLogsRepository from 'client-sdk/src/Repository/parcel-logs-repository';

import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@material-ui/lab';
import { Log } from '../parcels/interfaces';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },

    item: {
      marginBottom: '24px',

      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    title: {
      fontWeight: 500,
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '70%',
      marginTop: '30px',
      top: '180px',
      right: '33px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 600,
      // color: '#8A8A8A',
      marginRight: '10px',
      flex: 0.5,
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
    contentBox: {
      marginTop: '-1px',
      display: 'flex',
      flexDirection: 'column',
      fontSize: '14px',
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },

    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paperHistory: {
      alignItems: 'center',
    },
    tileBar: {
      zIndex: 10,
      position: 'fixed',
      top: '0px',
      right: '0px',
      display: 'flex',
      width: '100%',
      padding: '8px',
      justifyContent: 'center',
      borderRadius: '0',
      border: 'none'
    },
    tabs: {
      zIndex: 12,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      position: 'fixed',
      top: '52px',
      right: 0,
      borderBottom: 1,
      borderColor: '#000',
      width: '100%',
      backgroundColor: '#fff',

    },
    detail: {
      backgroundColor: 'white',
      padding: '5px',
      width: '100%',
    },
    btnBottom: {
      flexDirection: 'row',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#fff',
      bottom: '0',
      right: '0',
      padding: '15px 10px',
      zIndex: 2,
      borderTop: '1px solid lightgray',
    }
  })
);

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  CANCELLED: mdiClose, //'لغو شده',
  SHIPPED: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  SUBMITTED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  ASSIGNED: mdiPlaylistCheck, // تخصیص داده شده
  REGISTERED: mdiCheckBold, //'منطبق شده',
  CONFLICTED: mdiArrowCollapseAll, // مغایرت داده شده
  LOCATED: mdiFileTree, // جایگذاری شده
  RETURNING: mdiClipboardArrowLeft, // ریجکت شده
  UNLOADING: mdiTableArrowUp, // در حال بارگذاری
  UNLOADED: mdiTableCheck, // بارگذاری شده
};
const colorStatus = {
  SUBMITTED: theme.palette.green.main, //'ثپت شده',
  SHIPPED: theme.palette.green.main, //'ارسال شده',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  REGISTERED: theme.palette.green.main, //'منطبق شده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  RETURNING: theme.palette.warning.main, //'ریجکت شده',
  UNLOADING: theme.palette.orange.main, //'در حال بارگذاری ',
  UNLOADED: theme.palette.green.main, //'بارگذاری شده',
  LOCATED: 'purple', // جایگذاری شده
  ASSIGNED: theme.palette.blue.main, // تخصیص داده شده
  CONFLICTED: theme.palette.orange.main, // مغایرت داده شده
};

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({
    parcelId: { equals: props.match.params.id },
    page: 0,
    size: 1000,
  } as any);
  const [loading, setLoading] = useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [inventoryItemsWithSerialLoading, setInventoryItemsWithSerialLoading] =
    useState(false);
  const [parcel, setParcel] = useState<any>({});
  const [inventoryItems, setInventoryItems] = useState([]);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);
  const [printModal, setPrintModal] = useState(false as boolean);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);
  const [selected, setSelected] = React.useState<string[]>([]);
  const classes = useStyles();
  const [logs, setLogs] = useState([]);
  const [locateModal, setLocateModal] = useState(false)
  const [unitSerial, setUnitSerial] = useState("")
  const [itemId, setItemId] = useState('')
  const [values, setValues] = useState(0);

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'productName.contains',
        label: 'نام کالا',
        icon: mdiArchiveOutline,
      },
      {
        type: 'input',
        id: 'productCode.contains',
        label: 'کد کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'number',
        id: 'productId.equals',
        label: 'شناسه کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'number',
        id: 'skuId.equals',
        label: 'شناسه تنوع کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'skuCode.contains',
        label: 'کد تنوع کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'serialNumber.equals',
        label: 'سریال کالا',
        icon: mdiKeyOutline,
      },
    ]);
  };

  const getLogs = async (id: any) => {
    const payload = { id };
    try {
      const response = await parcelLogsRepository.getLogs({ payload });
      setLogs(response.data);
    } catch (error: any) {
      handleError(error.response);
    }
  };

  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error: any) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const clearnParcelInventoryItems = () => {
    setInventoryItemsCount(0);
    setInventoryItems([]);
  };
  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithSerialLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getInventoryItemsWithSerial(
          { payload },
          payload.callback
        );
      if (callback) {
        callback();
      }
      setInventoryItemsWithSerial(response.data.content);
      if (response.data.content.length === 0)
        handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
    } catch (error: any) {
      handleError(error.response);
    } finally {
      setInventoryItemsWithSerialLoading(false);
    }
  };
  useEffect(() => {
    const { id } = props.match.params;
    getParcelWithId(id);
    getLogs(id);
    getInventoryItemsWithSerial({
      ...filtersValues,
    });
    return () => {
      clearnParcelInventoryItems();
    };
  }, []);
  const getParcelInventoryItem = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getParcelInventoryItems({ payload });
      if (callback) {
        callback();
      }
      setInventoryItems(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
    } catch (error: any) {
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }
  };
  useEffect(() => {
    getParcelInventoryItem({
      ...filtersValues,
    });
    setupFilters();
  }, [filtersValues]);

  const handleClickFilter = () => {
    setOpenFilterBox(prev => !prev);
  };

  useEffect(() => {
    setFiltersValues({
      parcelId: { equals: props.match.params.id },
      page: 0,
      size: 1000,
    });
  }, [printModal]);

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleOpenPrintModal = () => {
    setPrintModal(true);
  };

  const handleClosePrintModal = () => {
    setPrintModal(false);
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = inventoryItems.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClickPrint = () => {
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(',')}`
    );
  };

  const locateParcelItem = async (e: any) => {
    e.preventDefault()
    const { id } = props.match.params;
    const payload = {
      id: itemId,
      body: { barcode: parseInt(unitSerial) },
      callback: () => {
        getParcelWithId(id);
        setLocateModal(false)
      },
    };
    try {
      setLoading(true);
      const callback = await inventoryItemsRepository.locateInventoryItemsUnit({
        payload,
      });
      handleNotfication(
        'تغییر وضعیت آیتم محموله با موفقیت انجام شد',
        'success'
      );
      callback && callback();
      setLoading(true);
    } catch (error: any) {
      handleError(error.response);
    }
  }

  const locateClick = (id: string) => {
    setItemId(id)
    setLocateModal(true)
  }

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValues(newValue);
  };

  const TabPanel = (props: any) => {
    const { children, values, index, ...other } = props;

    return (

      <div
        role="tabpanel"
        hidden={values !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {values === index && <Box>{children}</Box>}
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <Grid container>
        <Paper
          className={classes.tileBar}
        >
          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} className={classes.icon} />

          </Button>
          <Grid container xs={12} style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant="h6" component="h2">
              {`
         محموله
     
        `}
            </Typography>
            <span style={{ marginRight: '8px' }} >{parcel.id}</span>

          </Grid>
          <span >
            <Link to={'/mobile-home'} style={{ justifySelf: 'right' }}>
              <Icon path={mdiHomeOutline} size={1.2} color={'black'} />
            </Link>
          </span>
        </Paper>
      </Grid>
      <Box className={classes.tabs}>
        <Tabs
          values={values}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab label={parcel.status === 'ASSIGNED' ? " تخلیه کالاها" : " جایگذاری کالاها"} {...a11yProps(0)} />
          <Tab label=" جزییات" {...a11yProps(1)} />
          <Tab label="تاریخچه" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <Grid direction="row" justify="space-between" xs={12} style={{ marginBottom: '32px', marginTop: '55px' }}>
        <TabPanel values={values} index={0}>
          {
            parcel.status === 'REGISTERED' && <DetailsLocat {...props} />
          }
          {
            parcel.status === 'ASSIGNED' && <DetailsUnload {...props} />
          }
        </TabPanel>
        <TabPanel values={values} index={1}>
          <Grid xs={12}  >
            <Card>
              <CardContent>
                <div className={classes.item}>
                  <span className={classes.label}>{'وضعیت تحویل:  '}</span>
                  <span style={{ flex: 1 }}>
                    {translate(parcel.status, 'parcel')}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'انبار مقصد:  '}</span>

                  <span style={{ flex: 1 }}>{parcel.destinationName}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{' تنوع کالا:  '}</span>

                  <span style={{ flex: 1 }}>{parcel?.items?.length}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'تعداد آیتم ها:  '}</span>

                  <span style={{ flex: 1 }}>{inventoryItemsCount}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'نوع ارسال:  '}</span>
                  <span style={{ flex: 1 }}>
                    {translate(parcel.deliveryType)}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'شناسه:  '}</span>

                  <span style={{ flex: 1 }}>{parcel.id}</span>
                </div>
                <Divider style={{ width: '100%' }} />
              </CardContent>
              <CardContent>
                <div className={classes.item}>
                  <span className={classes.label}>{'تاریخ ثبت:  '}</span>
                  <span style={{ flex: 1 }}>
                    {parcel.deliveryDate &&
                      `${jMoment(parcel.shippingDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'تاریخ تحویل:  '}</span>
                  <span style={{ flex: 1 }}>
                    {parcel.shippingDate &&
                      `${jMoment(parcel.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'بازه تحویل:  '}</span>
                  <span style={{ flex: 1 }}>
                    {parcel.deliveryStartTime &&
                      jMoment(parcel.deliveryStartTime, 'hh:mm')
                        .locale('fa')
                        .format('HH:mm')}
                    {' - '}
                    {parcel.deliveryEndTime &&
                      jMoment(parcel.deliveryEndTime, 'hh:mm')
                        .locale('fa')
                        .format('HH:mm')}
                  </span>
                </div>
                <Divider style={{ width: '100%' }} />
              </CardContent>
              <CardContent>
                <div className={classes.item}>
                  <span className={classes.label}>{'ارسال کننده:  '}</span>
                  <span style={{ flex: 1 }}>
                    {parcel.partnerName ?? parcel.sellerName}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'نام مسئول حمل:  '}</span>

                  <span style={{ flex: 1 }}>{parcel.agentName}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'شماره همراه:  '}</span>
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(parcel.agentPhoneNumber)}
                  </span>
                </div>
                <Divider style={{ width: '100%' }} />
              </CardContent>
              <CardContent>
                <div className={classes.item}>
                  <span className={classes.label}>{'آدرس انبار :  '}</span>
                  <span style={{ flex: 1 }}>{parcel.destinationAddress}</span>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </TabPanel>
        <TabPanel values={values} index={2}>
          <Card  >

            <Timeline align="left"  >
              {logs
                ?.slice()
                .reverse()
                .map((log: Log, index: number) => (
                  <TimelineItem
                    className={classes.missingOppositeContent}
                    key={index}
                  >
                    <TimelineSeparator>
                      <TimelineDot
                        style={{
                          backgroundColor: colorStatus[log.newStatus],
                          border: index === 0 ? 'solid 4px #DF9234' : '',
                        }}
                      >
                        <Icon path={iconStatus[log.newStatus]} size={1} />
                      </TimelineDot>
                      {index !== logs?.length - 1 ? <TimelineConnector /> : ''}
                    </TimelineSeparator>
                    <TimelineContent className={classes.paperHistory}>
                      <div style={{ padding: '10px' }}>
                        <div className={classes.contentBox}>
                          <div style={{ flex: 1.5, textAlign: 'right' }}>

                            <span data-cy="status">
                              {translate(log.newStatus, 'parcel')}
                            </span>
                          </div>
                          <div
                            style={{
                              flex: 2,
                              textAlign: 'right',
                              justifyContent: 'center',
                            }}
                          >
                            <Can
                              role={authContext.user.role}
                              perform="user-name:dontShowInLogs"
                              no={() => (
                                <>
                                  <span>{log.modifierName}</span>
                                  <span> - </span>
                                </>
                              )}
                            />
                            <span data-cy="role">
                              {translate(log.modifierRole, 'user')}
                            </span>
                          </div>
                          <Typography component="div" style={{ flex: 1 }}>
                            {log.time &&
                              jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                .locale('fa')
                                .format('jYYYY/jMM/jDD - HH:mm')}
                          </Typography>
                        </div>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                ))}
            </Timeline>

          </Card>
        </TabPanel>
      </Grid>

      <Modal
        maxWidth="xl"
        onClose={handleClosePrintModal}
        open={printModal}
        title={
          <div style={{ textAlign: 'center' }}>
            <Icon path={mdiPrinter} size={4} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Grid container>
            <Grid
              container
              justify="flex-end"
              item
              xs={12}
              style={{ marginBottom: '5px' }}
            >
              <ClickAwayListener onClickAway={handleClickAway}>
                <div>
                  <Button
                    type="button"
                    onClick={handleClickFilter}
                    className={classes.iconButton}
                    aria-label="search"
                  >
                    {openFilterBox ? 'بستن' : 'جستجوی پیشرفته'}
                  </Button>
                  {openFilterBox ? (
                    <div
                      className={clsx(classes.filterBox, {
                        [classes.filterOpen]: openFilterBox,
                      })}
                    >
                      <RenderFilter
                        filters={filters}
                        onFilter={(filtervalues: any) => {
                          setFiltersValues({
                            ...removeEmptyValueObject(filtervalues),
                            parcelId: { equals: props.match.params.id },
                            page: 0,
                            size: 100,
                          });
                          setOpenFilterBox(false);
                        }}
                        setOpenFilterBox={setOpenFilterBox}
                      />
                    </div>
                  ) : null}
                </div>
              </ClickAwayListener>
            </Grid>
            <Grid xs={12} style={{ marginBottom: '20px', marginTop: '20px' }}>
              <LabelList
                selected={selected}
                handleSelectAllClick={handleSelectAllClick}
                handleClick={handleClick}
                data={inventoryItems}
              />
            </Grid>
            <Box mb={4} />
            <Grid xs={12} container justify="space-between" alignItems="center">
              <Pagination
                count={Math.ceil(inventoryItemsCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <Button
                disabled={selected.length < 1}
                variant="contained"
                color="secondary"
                size="large"
                onClick={handleClickPrint}
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {'پرینت سریال‌ها'}
              </Button>
            </Grid>
          </Grid>
        }
      />
      <Modal
        maxWidth="xl"
        onClose={() => setLocateModal(false)}
        open={locateModal}
        title={
          <div style={{ textAlign: "center" }}>
            <Icon style={{ color: "#0cc9c9" }} path={mdiPackageVariantClosed} size={2} />
          </div>
        }
        content={
          <form style={{ width: "500px" }} onSubmit={locateParcelItem}>
            <Typography style={{ marginBottom: '8px' }}>
              سریال یونیت مورد نظر را اسکن کنید:
            </Typography>
            <TextField
              fullWidth
              autoFocus
              label="سریال"
              variant='outlined'
              value={unitSerial}
              onChange={(e) => {
                setUnitSerial(e.target.value)
              }} />
            <Grid lg={12} container justifyContent="flex-end" style={{ marginTop: '16px' }}>
              <Button type="submit" style={{ alignSelf: "flex-end" }} color='secondary' variant='contained'>
                جایگذاری کالا
              </Button>
            </Grid>
          </form>
        } />
    </div>
  );
}

export default Details;
